import {Box, Stack, Typography} from "@mui/material";
import {c, mono, maxW, section} from "../landingTokens";

const STEPS = [
  {n: "01", title: "Instant call routing", body: "Your AI greets callers in under a second. No hold, no queue, no frustration."},
  {n: "02", title: "Smart intent detection", body: "Natural language understanding covers 100+ needs — billing, support, returns and more."},
  {n: "03", title: "Automated resolution", body: "Handles 60–70% of routine calls end to end: refunds, hours, order tracking, appointments."},
  {n: "04", title: "Seamless human handoff", body: "Escalates complex issues to an agent with the full transcript and context attached."},
];

export const HowItWorks = () => (
  <Box component="section" id="works" data-screen-label="How it works" sx={{px: section.px, pb: section.pb}}>
    <Box
      sx={{
        maxWidth: maxW,
        mx: "auto",
        background: "linear-gradient(135deg, #6258E8 0%, #9A6EF5 52%, #C87CF0 100%)",
        borderRadius: "36px",
        p: "clamp(32px, 5vw, 68px)",
        position: "relative",
        overflow: "hidden",
        mt: 10,
      }}
    >
      <Box aria-hidden sx={{position: "absolute", top: -120, right: -80, width: 420, height: 420, borderRadius: "50%", bgcolor: "rgba(255,255,255,0.14)"}} />
      <Box aria-hidden sx={{position: "absolute", bottom: -140, left: -100, width: 340, height: 340, borderRadius: "50%", bgcolor: "rgba(255,255,255,0.12)"}} />

      <Box sx={{position: "relative"}}>
        <Typography sx={{fontFamily: mono, fontSize: "11.5px", letterSpacing: "0.16em", textTransform: "uppercase", color: "rgba(255,255,255,0.82)", mb: 2.25}}>
          How it works
        </Typography>
        <Typography component="h2" sx={{fontSize: "clamp(32px, 4.6vw, 56px)", lineHeight: 1.05, letterSpacing: "-0.035em", fontWeight: 600, color: c.white, maxWidth: 760, mb: 1.75, textWrap: "balance"}}>
          AI that works like your best agent — instantly.
        </Typography>
        <Typography sx={{fontSize: 18, lineHeight: 1.5, color: "rgba(255,255,255,0.86)", maxWidth: 560, mb: {xs: 5, md: 7}}}>
          Four steps between the ring and a resolved request.
        </Typography>

        {/* Connected numbered flow — reads as a sequence, not four equal boxes. */}
        <Box className="reveal-stagger" sx={{display: "grid", gridTemplateColumns: {xs: "1fr", sm: "1fr 1fr", md: "repeat(4, 1fr)"}, gap: {xs: 4, md: 2.5}}}>
          {STEPS.map((s, i) => (
            <Box key={s.n}>
              <Stack direction="row" alignItems="center" sx={{mb: 2.5}}>
                <Box
                  sx={{
                    flexShrink: 0,
                    width: 48,
                    height: 48,
                    borderRadius: "50%",
                    display: "grid",
                    placeItems: "center",
                    bgcolor: "rgba(255,255,255,0.2)",
                    backdropFilter: "blur(6px)",
                    fontFamily: mono,
                    fontSize: 15,
                    fontWeight: 600,
                    color: c.white,
                  }}
                >
                  {s.n}
                </Box>
                {/* Connector to the next node (desktop only). */}
                {i < STEPS.length - 1 && (
                  <Box aria-hidden sx={{display: {xs: "none", md: "block"}, flex: 1, height: "2px", ml: 1.5, background: "linear-gradient(90deg, rgba(255,255,255,0.45), rgba(255,255,255,0.12))"}} />
                )}
              </Stack>
              <Typography sx={{fontSize: 19, letterSpacing: "-0.015em", fontWeight: 600, color: c.white, mb: 1}}>{s.title}</Typography>
              <Typography sx={{fontSize: "14.5px", lineHeight: 1.55, color: "rgba(255,255,255,0.9)", maxWidth: 240}}>{s.body}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  </Box>
);
